// extracted by mini-css-extract-plugin
export default {"dashboardCard":"DashboardCard_dashboardCard__1ggH1","headerContainer":"DashboardCard_headerContainer__VjkoU"};